import { gql } from 'graphql-request';

export const GET_FEATURE_FLAGS = gql`
  query GetFeatureFlags {
    featureFlags {
      id
      name
      description
      isEnabled
      modifiedAt
      createdAt
      createdById
      updatedById
    }
  }
`;

export const CREATE_FEATURE_FLAG = gql`
  mutation CreateFeatureFlag($object: FeatureFlagsInsertInput!) {
    insertFeatureFlagsOne(object: $object) {
      id
      name
      description
      isEnabled
      modifiedAt
      createdAt
    }
  }
`;

export const UPDATE_FEATURE_FLAG = gql`
  mutation UpdateFeatureFlag($id: uuid!, $_set: FeatureFlagsSetInput!) {
    updateFeatureFlagsByPk(pkColumns: { id: $id }, _set: $_set) {
      id
      name
      description
      isEnabled
      modifiedAt
      createdAt
      createdById
      updatedById
    }
  }
`;

export const DELETE_FEATURE_FLAG = gql`
  mutation DeleteFeatureFlag($id: uuid!) {
    deleteFeatureFlagsByPk(id: $id) {
      id
    }
  }
`;

export const GET_FEATURE_FLAG_BY_ID = gql`
  query GetFeatureFlagById($id: uuid!) {
    featureFlags_by_pk(id: $id) {
      id
      name
      description
      isEnabled
      modifiedAt
      createdById
      updatedById
    }
  }
`;

export const GET_FEATURE_FLAG_BY_NAME = gql`
  query GetFeatureFlagByName($name: String!) {
    featureFlags(where: { name: { _eq: $name } }) {
      id
      name
      description
      isEnabled
      modifiedAt
      createdById
      updatedById
    }
  }
`;

export const GET_FEATURE_FLAG_LOGS = gql`
  query GetFeatureFlagLogs {
    featureFlagLogs(orderBy: { createdAt: DESC }) {
      id
      featureFlagId
      oldData
      newData
      action
      oldName
      newName
      oldDescription
      newDescription
      oldIsEnabled
      newIsEnabled
      changed_by {
        email
        firstName
        id
        lastName
      }
      changedById
      createdAt
      modifiedAt
    }
  }
`;
